import "public/css/components.loader.scss";
import { Dimmer, Loader as LoaderUI } from "semantic-ui-react";
import React from "react";

export const Loader = (props) => (
	<div className="loader-frame">
		<Dimmer active inverted>
			<LoaderUI />
		</Dimmer>
	</div>
);
